import React from 'react';

type Props = {
  isOpen: boolean;
  onClick: () => void;
  className?: string;
  style?: React.CSSProperties;
};

export function TranscriptionToggleButton({ isOpen, onClick, className, style }: Props) {
  return (
    <button
      className={className}
      style={style}
      onClick={onClick}
      aria-label={isOpen ? 'Hide Transcript' : 'Show Transcript'}
      title="Transcription"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="18"
        height="18"
        fill="currentColor"
      >
        <path d="M4 4h16v2H4zM4 8h10v2H4zM4 12h16v2H4zM4 16h10v2H4z" />
      </svg>
    </button>
  );
}
